<template>
  <div class="ca-status-indicator" v-if="caData && caData.code">
    <q-icon
      :name="getStatusIcon()"
      :color="getStatusColor()"
      size="sm"
      class="cursor-pointer"
    >
      <q-tooltip
        anchor="top middle"
        self="bottom middle"
        :offset="[10, 10]"
        class="ca-tooltip"
      >
        <div class="ca-tooltip-content">
          <div class="row items-center q-mb-xs">
            <q-icon
              :name="getStatusIcon()"
              :color="getStatusColor()"
              size="xs"
              class="q-mr-xs"
            />
            <span class="text-weight-medium">{{ getStatusText() }}</span>
          </div>
          <div v-if="caData && caData.expires_in" class="text-caption">
            <strong>Validade:</strong> {{ formatDate(caData.expires_in) }}
          </div>
          <div v-if="caData && caData.code" class="text-caption">
            <strong>CA:</strong> {{ caData.code }}
          </div>
        </div>
      </q-tooltip>
    </q-icon>
  </div>
</template>

<script>
export default {
  name: "CaStatusIndicator",
  props: {
    caData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getStatusIcon() {
      const status = this.caData.status?.toLowerCase();

      switch (status) {
        case "válido":
        case "valid":
          return "check_circle";
        case "vencido":
        case "expired":
          return "error";
        case "vazio":
        case "empty":
          return "warning";
        default:
          return "help_outline";
      }
    },

    getStatusColor() {
      const status = this.caData.status?.toLowerCase();

      switch (status) {
        case "válido":
        case "valid":
          return "positive";
        case "vencido":
        case "expired":
          return "negative";
        case "vazio":
        case "empty":
          return "warning";
        default:
          return "grey-6";
      }
    },

    getStatusText() {
      const status = this.caData.status;

      switch (status?.toLowerCase()) {
        case "válido":
        case "valid":
          return "Válido";
        case "vencido":
        case "expired":
          return "Vencido";
        case "vazio":
        case "empty":
          return "Vazio";
        default:
          return "Desconhecido";
      }
    },

    formatDate(dateString) {
      if (!dateString) return "N/A";

      try {
        // Se a data está no formato YYYY-MM-DD, tratamos como data local
        if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = dateString.split("-");
          // Cria a data considerando o fuso horário local (mês -1 porque JavaScript usa 0-11)
          const date = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(day)
          );
          return date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        } else {
          // Para outros formatos, usa o comportamento padrão
          const date = new Date(dateString);
          return date.toLocaleDateString("pt-BR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
        }
      } catch (error) {
        return "Data inválida";
      }
    },
  },
};
</script>

<style scoped>
.ca-status-indicator {
  display: inline-flex;
  align-items: center;
  margin-left: 0.5rem;
}

.ca-tooltip {
  background: rgba(0, 0, 0, 0.87);
  color: white;
  border-radius: 4px;
  padding: 8px 12px;
  max-width: 200px;
}

.ca-tooltip-content {
  font-size: 12px;
  line-height: 1.4;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
